import { useState } from "react";

export const useCustomTooltip = (chartContainerRef) => {
  const [isTooltipHidden, setIsTooltipHidden] = useState(true);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const showTooltip = (e) => {
    if (chartContainerRef?.current) {
      setIsTooltipHidden(false);
      const rect = chartContainerRef.current.getBoundingClientRect();

      setTooltipPosition({
        x: e.pageX - rect.left,
        y: e.pageY - rect.top
      });
    }
  };

  const hideTooltip = () => {
    setIsTooltipHidden(true);
  };

  return { isTooltipHidden, tooltipPosition, showTooltip, hideTooltip };
};
